<template>
    <div class="card mb-25 border-0 bg-white add-user-card">
        <div class="card-header">
            <h3 class="text-black fw-semibold">Modification d'un magasin</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="magasinForm" @submit="updateMagasin" :validation-schema="magasinSchema">
                <!-- <div class="col-md-3">
                    <br />
                    <div class="form-check mt-3 mb-15 mb-sm-20 mb-md-25">
                        <label for="estActif" class="form-check-label fw-medium position-relative top-1">
                            Est Principal ?
                        </label>
                        <input id="estPrincipal" name="estPrincipal" v-model="estPrincipal" :value="estPrincipal"
                            type="checkbox" class="form-check-input shadow-none" />
                        <ErrorMessage name="estPrincipal" class="text-danger" />
                    </div>
                </div> -->
                <div class="row mb-10">
                    <div class="col-md-3 mb-3">
                        <div class="form-group ">
                            <label class="d-block text-black fw-semibold mb-10">
                                Code du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="code" type="text" v-model="code"
                                class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le code du magasin" />
                            <ErrorMessage name="code" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <div class="form-group ">
                            <label class="d-block text-black fw-semibold mb-10">
                                Nom du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="nomMagasin" type="text" v-model="nomMagasin"
                                class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le nom magasin" />
                            <ErrorMessage name="nomMagasin" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-5  mb-3">
                        <div class="form-group">
                            <label class="d-block text-black fw-semibold mb-10">
                                Magasinier <span class="text-danger">*</span>
                            </label>
                            <Field name="user"  v-model="selectedUser" v-slot="{ field }">
                                <Multiselect :options="personnelOptions" :searchable="true" track-by="label"
                                    label="label" v-bind="field"
                                    placeholder="Sélectionner le magasinier" />
                            </Field>
                            <ErrorMessage name="user" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="form-group">
                            <label class="d-block text-black fw-semibold mb-10">
                                Adresse du magasin <span class="text-danger">*</span>
                            </label>
                            <Field name="adresse" type="text" v-model="adresse"
                                class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer l'adresse" />
                            <ErrorMessage name="adresse" class="text-danger" />
                        </div>
                    </div>
                </div>
                <button ref="submitButton" class="btn btn-primary me-5" type="submit" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ loading ? 'Modification en cours...' : 'Modifier le magasin' }}
                </button>
                <button class="btn btn-danger" type="button" @click="router.push({ name: 'ListeMagasin' })">
                    Annuler
                </button>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import axios from 'axios';
import { Magasin } from '@/models/Magasin';

export default defineComponent({
    name: "EditMagasin",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },

    setup: () => {
        const magasinSchema = Yup.object().shape({
            nomMagasin: Yup.string().required('Le nom du magasin est obligatoire'),
            code: Yup.string().required('Le code du magasin est obligatoire'),
            user: Yup.string().required('Le magasinier est obligatoire'),
            adresse: Yup.string().required('L\'adresse est obligatoire'),
        });

        const estPrincipal = ref(false);
        const personnelOptions = ref([]);
        const magasinForm = ref<Magasin | null>(null);
        const valuess = ref();
        const submitButton = ref<HTMLButtonElement | null>(null);
        const currentDateTime = ref(getCurrentDateTime());
        const code = ref('');
        const nomMagasin = ref('');
        const adresse = ref('');
        const selectedUser = ref(null);
        const loading = ref(false);
        const magasinId = ref(null);

        const router = useRouter();
        const route = useRoute();
        const isDisable = ref(true);

        function getCurrentDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }

        // Fonction pour charger les données du magasin à modifier
        const loadMagasinData = async () => {
            try {
                loading.value = true;
                magasinId.value = route.params.id;
                
                if (!magasinId.value) {
                    error('ID du magasin non fourni');
                    router.push({ name: 'ListeMagasin' });
                    return;
                }

                const response = await ApiService.get(`/magasins/${magasinId.value}`);
                
                if (response.data.code === 200) {
                    const magasinData = response.data.data;
                    
                    // Remplir les champs du formulaire
                    code.value = magasinData.code;
                    nomMagasin.value = magasinData.nomMagasin;
                    adresse.value = magasinData.adresse;
                    estPrincipal.value = magasinData.estPrincipal || false;
                    
                    // Sélectionner l'utilisateur
                    if (magasinData.user) {
                        selectedUser.value = magasinData.user.id    ;
                    }
                } else {
                    error('Erreur lors du chargement des données du magasin');
                    router.push({ name: 'ListeMagasin' });
                }
            } catch (err) {
                console.error('Erreur lors du chargement du magasin:', err);
                error('Erreur lors du chargement des données du magasin');
                router.push({ name: 'ListeMagasin' });
            } finally {
                loading.value = false;
            }
        };

        const updateMagasin = async (values: any, { resetForm }) => {
            if (submitButton.value) {
                submitButton.value.disabled = true;
            }

            loading.value = true;
            
            values = values as Magasin;
            values.id = magasinId.value;
            values.estPrincipal = estPrincipal.value;
            
            // S'assurer que les valeurs des champs sont correctes
            values.code = code.value;
            values.nomMagasin = nomMagasin.value;
            values.adresse = adresse.value;
            values.user = selectedUser.value ? selectedUser.value.value : null;
            
            console.log("Données à modifier ===> ", values);
            
            try {
                const response = await ApiService.put(`/magasins/${magasinId.value}`, values);
                
                if (response.data.code === 200) {
                    success(response.data.message || 'Magasin modifié avec succès');
                    router.push({ name: 'ListeMagasin' });
                } else {
                    error(response.data.message || 'Erreur lors de la modification');
                }
            } catch (err) {
                console.error('Erreur lors de la modification:', err);
                error(err.response?.data?.message || 'Erreur lors de la modification du magasin');
            } finally {
                loading.value = false;
                if (submitButton.value) {
                    submitButton.value.disabled = false;
                }
            }
        };

        const fetchPersonnel = async () => {
            try {
                const response = await axios.get('all/users');
                const userData = response.data.data;
                console.log("Personnel ===> ", userData);
                personnelOptions.value = userData.map((user) => ({
                    value: user.id,
                    label: `${user.nom} ${user.prenom}`,
                }));
            } catch (error) {
                console.log("Erreur lors du chargement du personnel ==> ", error);
            }
        };

        onMounted(async () => {
            currentDateTime.value = getCurrentDateTime();
            await fetchPersonnel();
            await loadMagasinData();
        });

        return {
            loading,
            isDisable,
            submitButton,
            currentDateTime,
            getCurrentDateTime,
            valuess,
            updateMagasin,
            magasinSchema,
            estPrincipal,
            personnelOptions,
            code,
            nomMagasin,
            adresse,
            selectedUser,
            router,
            route
        };
    },
});
</script>

<style scoped></style>
